const isBrowser = typeof window !== "undefined";

let prefetchPromise = null;

const preloadImage = (src) =>
  new Promise((resolve) => {
    if (!src || !isBrowser) {
      resolve();
      return;
    }

    const img = new Image();
    img.decoding = "async";
    img.onload = () => resolve();
    img.onerror = () => resolve();
    img.src = src;
  });

const fetchOfferingsProducts = async () => {
  if (!isBrowser) {
    return [];
  }

  const isLocalhost =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";

  const endpoints = isLocalhost
    ? [
        "http://localhost:9999/.netlify/functions/list-stripe-products",
        "/.netlify/functions/list-stripe-products",
      ]
    : ["/.netlify/functions/list-stripe-products"];

  for (const endpoint of endpoints) {
    try {
      const response = await fetch(endpoint);
      if (!response.ok) {
        continue;
      }

      const payload = await response.json();
      return Array.isArray(payload?.products) ? payload.products : [];
    } catch (error) {
      // Try the next endpoint quietly.
    }
  }

  return [];
};

export const prefetchOfferingsImages = async ({ limit = 6 } = {}) => {
  if (!isBrowser) {
    return;
  }

  if (window.__offeringsImagesPrefetched) {
    return;
  }

  if (prefetchPromise) {
    return prefetchPromise;
  }

  prefetchPromise = (async () => {
    const products = await fetchOfferingsProducts();
    const imageUrls = products
      .map((product) => product?.images?.[0])
      .filter(Boolean)
      .slice(0, limit);

    await Promise.all(imageUrls.map((src) => preloadImage(src)));
    window.__offeringsImagesPrefetched = true;
  })();

  try {
    await prefetchPromise;
  } catch (error) {
    // Ignore prefetch failures to avoid affecting UX.
  }
};

export const prefetchOfferingsImagesOnIdle = () => {
  if (!isBrowser || window.__offeringsImagesPrefetched) {
    return;
  }

  const run = () => {
    prefetchOfferingsImages();
  };

  if (typeof window.requestIdleCallback === "function") {
    window.requestIdleCallback(run, { timeout: 2000 });
    return;
  }

  window.setTimeout(run, 500);
};
